import { forwardRef, useEffect, useState } from "react";
import { WidgetProps, WidgetRef } from "../../../types/widget";
import { styles } from "../styles";
import { useThemeStore } from "../../../stores";
import { Row } from "../../containers";
import { Heading } from "../../typography";
import { BarChart, axisClasses } from "@mui/x-charts";
import { formatID } from "../income-spend-chart-widget/utils";
import { CTCCResponseData } from "./types";
import Api from "../../../api/api";
import { getRangeWeek } from "../../../utils";
import ChartLegend from "../../chart-legend";

const CHART_INFO = {
    cheque: {
        label: "دریافت چکی",
        color: "#F9A825",
    },
    cash: {
        label: "دریافت نقدی",
        color: "#6A1B9A",
    },
}

const CashToChequeWidget = forwardRef<WidgetRef, WidgetProps>((props, ref) => {
    const theme = useThemeStore(s => s.theme);

    const [data, setData] = useState<CTCCResponseData>([]);

    useEffect(() => {
        Api.getData<CTCCResponseData>(
            `/widget/cash_to_cheque_chart?from=${getRangeWeek(Date.now(), 2).from}&to=${getRangeWeek(Date.now(), 2).to}`
        ).then(res => {
            setData(res);
        }).catch(err => {
            console.log(err);
        })
    }, [])

    return (
        <div
        ref={ref}
        style={{
          background: theme.overlay,
          position: "relative",
          ...styles.container,
        }}
        >
            <Row>
                <Heading color={theme.textOnOverlay} >نسبت دریافت نقدی به چک</Heading>
            </Row>

            <BarChart
                dataset={data}
                series={[
                    {
                        label: CHART_INFO.cash.label,
                        color: CHART_INFO.cash.color,
                        dataKey: "total_rcvd_cash",
                        stack: "stack"
                    },
                    {
                        label: CHART_INFO.cheque.label,
                        color: CHART_INFO.cheque.color,
                        dataKey: "total_rcvd_cheques",
                        stack: "stack"
                    }
                ]}
                xAxis={[
                    {
                    scaleType: "band",
                    dataKey: "_id",
                    valueFormatter: (value) => formatID("daily", value),
                    },
                ]}
                yAxis={[
                    {
                    tickLabelStyle: {
                        textAnchor: "start",
                        angle: 45
                    }
                    },
                ]}
                sx={() => ({
                    [`.${axisClasses.root}`]: {
                        [`.${axisClasses.tick}, .${axisClasses.tickLabel}, .${axisClasses.line}`]:
                        {
                            stroke: theme.textOnOverlay,
                        },
                    },
                })}
                slotProps={{legend: {hidden: true}}}
                height={200}
            />

            <Row gap={50}>
                <ChartLegend color={CHART_INFO.cash.color} label={CHART_INFO.cash.label} />
                <ChartLegend color={CHART_INFO.cheque.color} label={CHART_INFO.cheque.label} />
            </Row>
        </div>
    )
})

export default CashToChequeWidget;